import { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
  className?: string;
}

export default function FormField({ label, required, error, children, className = '' }: FormFieldProps) {
  return (
    <div className={`ios-form-field ${className}`}>
      <div className="ios-form-label">
        {label}
        {required && <span className="ios-form-required">*</span>}
      </div>
      {children}
      {error && <div className="ios-form-error">{error}</div>}
    </div>
  );
}
